import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { catalogApi } from '../lib/api'
import { kvSet } from '../lib/db'
import { useApp } from '../lib/store'
import { AppBar } from '../components/AppBar'

export function ShopSettingsScreen() {
  const nav = useNavigate()
  const shop = useApp((s) => s.shop)
  const say = useApp((s) => s.say)

  const [name, setName] = useState(shop?.name ?? '')
  const [address, setAddress] = useState(shop?.address ?? '')
  const [phone, setPhone] = useState(shop?.phone ?? '')
  const [taxCode, setTaxCode] = useState(shop?.taxCode ?? '')
  const [kind, setKind] = useState<'FnB' | 'Retail'>(shop?.businessType ?? 'FnB')
  const [busy, setBusy] = useState(false)

  const rate = kind === 'FnB' ? '4,5%' : '1,5%'
  const kindChanged = kind !== shop?.businessType

  async function save() {
    if (!name.trim()) {
      say('Chưa đặt tên quán')
      return
    }

    setBusy(true)
    try {
      const saved = await catalogApi.saveShop({
        name: name.trim(),
        address: address.trim() || null,
        phone: phone.trim() || null,
        taxCode: taxCode.trim() || null,
        businessType: kind,
      })

      const next = {
        ...shop!,
        name: saved.name,
        address: saved.address,
        phone: saved.phone,
        taxCode: saved.taxCode,
        businessType: saved.businessType,
        vatRatePermille: saved.vatRatePermille,
        pitRatePermille: saved.pitRatePermille,
      }
      await kvSet('shop', next)
      useApp.setState({ shop: next })

      say('Đã lưu thông tin quán')
      nav('/settings')
    } catch (e) {
      say(e instanceof Error ? e.message : 'Chưa lưu được')
    }
    setBusy(false)
  }

  return (
    <div className="screen">
      <AppBar title="Thông tin quán" onBack={() => nav('/settings')} />

      <div className="body">
        <p className="hint">
          Tên, địa chỉ và mã số thuế được in lên tờ bill và ghi vào sổ doanh thu. Khai đúng ngay
          từ đầu thì cuối quý khỏi phải sửa lại từng dòng.
        </p>

        <label className="field">
          <span>Tên quán</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Cà phê Sáu Lúa"
            maxLength={120}
          />
        </label>

        <label className="field">
          <span>Địa chỉ</span>
          <input
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            placeholder="142 Nguyễn Thị Minh Khai, P. Đa Kao, Q.1"
            maxLength={250}
          />
        </label>

        <div className="field-row">
          <label className="field">
            <span>Điện thoại</span>
            <input
              type="tel"
              inputMode="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="0912 345 678"
            />
          </label>

          <label className="field">
            <span>Mã số thuế</span>
            <input
              inputMode="numeric"
              value={taxCode}
              onChange={(e) => setTaxCode(e.target.value)}
              placeholder="0123456789"
              maxLength={50}
            />
          </label>
        </div>

        <div className="field">
          <span>Ngành nghề</span>
          <div className="seg">
            <button type="button" aria-pressed={kind === 'FnB'} onClick={() => setKind('FnB')}>
              🍜 Ăn uống
            </button>
            <button type="button" aria-pressed={kind === 'Retail'} onClick={() => setKind('Retail')}>
              🛒 Bán lẻ
            </button>
          </div>
        </div>

        <div className={`card${kindChanged ? ' warn-card' : ''}`}>
          <div className="pay-row">
            <span>Tỷ lệ thuế trên doanh thu</span>
            <b className="num">{rate}</b>
          </div>
          <p className="note">
            {kind === 'FnB'
              ? 'Ăn uống, dịch vụ có nguyên vật liệu: 3% GTGT + 1,5% TNCN.'
              : 'Bán lẻ hàng hoá: 1% GTGT + 0,5% TNCN.'}
            {kindChanged && ' Đổi ngành sẽ đổi luôn tỷ lệ thuế cho các quý tính từ giờ.'}
          </p>
        </div>
      </div>

      <div className="dock">
        <button type="button" className="btn btn-brand btn-lg grow" onClick={save} disabled={busy}>
          {busy ? 'Đang lưu…' : 'Lưu'}
        </button>
      </div>
    </div>
  )
}
